export enum FinancialConnectionRefreshRequestStatus {
    Pending = 'pending',
    Succeeded = 'succeeded',
    Failed = 'failed',
    Canceled = 'canceled',
}
